// Gemeinsame Helfer für Projekt-Pipeline, Monatsauswahl und Vertriebler-Rangliste.

// „Gewonnen“ = Auftrag unterschrieben oder eine spätere Phase (Status-Labels aus project_status.py).
const WON_STATUSES = new Set([
  "Gewonnen", "Auftrag unterschrieben", "Auftragsbestätigung", "Anzahlung erhalten",
  "Termin Heizlast + Verbaucheck", "Übergabe Installation", "Installation geplant", "Montagebeginn",
  "Inbetriebnahme", "Installation abgeschlossen", "Übergabe",
]);
export const isWon = (p) => WON_STATUSES.has(p.status) || p.stage === "auftrag_unterschrieben";

export const NO_OWNER = "__none__";
// Gelöschte/unbekannte Vertriebler (kein Name) landen gemeinsam unter „Ohne Vertriebler“.
export const ownerKey = (p) => (p.owner_user_id && p.owner_name ? p.owner_user_id : NO_OWNER);
export const ownerCount = (projects) => new Set((projects || []).map(ownerKey)).size;
export const ownerLabel = (projects, key) => {
  const p = (projects || []).find((x) => ownerKey(x) === key);
  return p && key !== NO_OWNER ? p.owner_name : "Ohne Vertriebler";
};

export const eur0 = (n) => `${new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(n || 0)} €`;
export const netOf = (p) => Number(p.offers_total_net || 0);

// Umsatz-Monat: Unterschrift (gewonnen) bzw. Datum des aktuellen Angebots – vom Backend als revenue_date.
export const monthKey = (p) => {
  if (!p.revenue_date) return "";
  const d = new Date(p.revenue_date);
  return Number.isNaN(d.getTime()) ? "" : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
export const monthLabel = (key) => {
  const [y, m] = key.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("de-DE", { month: "long", year: "numeric" });
};
